import React from 'react';
import { Button } from './ui/button';
import { Check, Calendar, MapPin, Sparkles } from 'lucide-react';
import { retreatData } from '../utils/mockData';

const Retreat = ({ onContactClick }) => {
  const activities = [
    "Gentle mobility mornings",
    "Countryside walks",
    "Sound bath sessions",
    "Massages",
    "Hot tub evenings",
    "Pizza making night",
    "Games & social time",
    "Tarot readings (optional)"
  ];

  return (
    <section id="retreat" className="retreat-section">
      <div className="container mx-auto px-4">
        
        {/* Hero Banner */}
        <div className="retreat-hero">
          <img 
            src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/go5wqk6r_3f7674c2-2a69-4143-9790-e0014614393a.avif"
            alt="Peaceful countryside retreat"
            className="retreat-hero-image"
          />
          <div className="retreat-hero-content">
            <Sparkles className="retreat-sparkle-icon" size={48} />
            <h2 className="retreat-main-title">The Emotional Reset Retreat</h2>
            <p className="retreat-tagline">{retreatData.tagline}</p>
            <div className="retreat-badges">
              <span className="retreat-badge">
                <Calendar size={16} />
                5-8 Nov 2026
              </span>
              <span className="retreat-badge">
                <MapPin size={16} />
                Exmoor, Somerset
              </span>
            </div>
          </div>
        </div>

        {/* Intro Section */}
        <div className="retreat-intro">
          <p className="retreat-intro-lead">{retreatData.description}</p>
          <p className="retreat-intro-text">{retreatData.fullDescription}</p>
        </div>

        {/* Image Gallery Row */}
        <div className="retreat-gallery">
          <div className="retreat-gallery-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/loar620a_a38494e6-8b35-402f-9061-f2783a738580.avif"
              alt="Retreat venue"
            />
            <span className="retreat-gallery-label">Hidden Valley</span>
          </div>
          <div className="retreat-gallery-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/ic97krst_e734d5ee-4b26-4358-ab54-b473f53b1e73.avif"
              alt="Lake with rowing boat"
            />
            <span className="retreat-gallery-label">Peaceful Surroundings</span>
          </div>
          <div className="retreat-gallery-item">
            <img 
              src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/gw2bhjn3_d5b4530d-3b26-4487-9e3e-f03389216664.avif"
              alt="Hot tub"
            />
            <span className="retreat-gallery-label">Relaxation Space</span>
          </div>
        </div>

        {/* Pricing Card */}
        <div className="retreat-pricing-card">
          <div className="retreat-pricing-header">
            <div className="retreat-price-display">
              <span className="retreat-price-main">£550</span>
            </div>
            <p className="retreat-price-includes">3 nights / 4 days • All meals included • Max 11 guests</p>
          </div>
        </div>

        {/* Activities Grid */}
        <div className="retreat-activities">
          <h3 className="retreat-section-title">What's Included</h3>
          <div className="retreat-activities-grid">
            {activities.map((activity, index) => (
              <div key={index} className="retreat-activity-card">
                <Check size={18} className="retreat-check" />
                <span>{activity}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Feature Image */}
        <div className="retreat-feature">
          <img 
            src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/075wst17_9befefbe-bb46-4503-9861-e8b53e835c9a.avif"
            alt="Retreat experience"
            className="retreat-feature-image"
          />
          <div className="retreat-feature-overlay">
            <h4>Rest. Reset. Rejuvenate.</h4>
            <p>Nothing is compulsory. You're always free to join in—or rest when you need to.</p>
          </div>
        </div>

        {/* Who It's For */}
        <div className="retreat-who">
          <h3 className="retreat-section-title">This Retreat Is For You If...</h3>
          <div className="retreat-who-list">
            {retreatData.forWho.ideal.map((item, index) => (
              <div key={index} className="retreat-who-item">
                <div className="retreat-who-bullet"></div>
                <p>{item}</p>
              </div>
            ))}
          </div>
          <p className="retreat-who-note">{retreatData.forWho.note}</p>
        </div>

        {/* Outcome Box */}
        <div className="retreat-outcome">
          <Sparkles size={32} className="retreat-outcome-icon" />
          <p className="retreat-outcome-text">{retreatData.whyAttend.outcome}</p>
        </div>

        {/* CTA */}
        <div className="retreat-cta">
          <h3 className="retreat-cta-title">Limited to 11 Guests</h3>
          <p className="retreat-cta-text">Register your interest to receive full booking details and secure your place.</p>
          <Button 
            onClick={onContactClick}
            className="retreat-cta-button"
            size="lg"
            data-testid="retreat-register-btn"
          >
            Register Your Interest
          </Button>
        </div>

      </div>
    </section>
  );
};

export default Retreat;
